import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, PieChart, ArrowDownLeft, User } from 'lucide-react';

const MobileBottomNav = () => {
    const location = useLocation();
    
    const navItems = [
        { to: '/dashboard', icon: LayoutDashboard, label: 'Home' },
        { to: '/portfolio', icon: PieChart, label: 'Portfolio' },
        { to: '/deposit', icon: ArrowDownLeft, label: 'Deposit' },
        { to: '/profile', icon: User, label: 'Profile' },
    ];

    // Don't show on login/register pages
    if (location.pathname === '/login' || location.pathname === '/register') {
        return null;
    }

    return (
        <nav className="mobile-bottom-nav md:hidden" data-testid="mobile-bottom-nav">
            <div className="flex items-center justify-around h-full">
                {navItems.map((item) => {
                    const isActive = location.pathname === item.to;
                    return (
                        <NavLink
                            key={item.to}
                            to={item.to}
                            className={`flex flex-col items-center justify-center gap-1 py-2 px-4 min-w-[70px] transition-all duration-200 ${
                                isActive 
                                    ? 'text-[#5BA4A4]' 
                                    : 'text-gray-500 hover:text-gray-300'
                            }`}
                            data-testid={`bottom-nav-${item.label.toLowerCase()}`}
                        >
                            <div className={`relative ${isActive ? 'scale-110' : ''} transition-transform`}>
                                {isActive && (
                                    <div className="absolute -inset-2 bg-[#5BA4A4]/20 rounded-full blur-md" />
                                )}
                                <item.icon 
                                    size={22} 
                                    strokeWidth={isActive ? 2 : 1.5}
                                    className={`relative ${isActive ? 'drop-shadow-[0_0_6px_rgba(91,164,164,0.7)]' : ''}`}
                                />
                            </div>
                            <span className={`text-[10px] font-rajdhani uppercase tracking-wider ${isActive ? 'font-bold' : 'font-medium'}`}>
                                {item.label}
                            </span>
                            {isActive && (
                                <div className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[#5BA4A4] rounded-full shadow-[0_0_8px_rgba(91,164,164,0.8)]" />
                            )}
                        </NavLink>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
